export default "__VITE_ASSET__DtZye3gI__"